import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ChangeDeliveryMethodNOOverlayDialog extends Component {
    constructor(props) {
        super(props);
		this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('ChangeDeliveryMethodNOOverlayDialog');
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="changeDeliveryMethodNOOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Change Shipping Method</h2>
                    <p>Your order has enough points to qualify for direct shipment.</p>
                    <p><b>ADC Truckload orders are tailgate delivery only and cannot include uncrating or any installation services.</b></p>
                    <p><b>Would you like to have it shipped ADC Truckload?</b></p>
                    <div className="noButtonContainer">
						<a onClick={(e) => this.props.continueDeliveryWith(false, e)} href="" className="noButton blueButton">No</a>
                    </div>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={(e) => this.props.continueDeliveryWith("ADC Truckload", e)}>Yes</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

ChangeDeliveryMethodNOOverlayDialog = connect(mapStateToProps)(ChangeDeliveryMethodNOOverlayDialog);
export default ChangeDeliveryMethodNOOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/changeDeliveryMethodNOOverlayDialog.js